import { render, staticRenderFns } from "./IssueIcon.vue?vue&type=template&id=0f086bc8&scoped=true&"
import script from "./IssueIcon.vue?vue&type=script&lang=ts&"
export * from "./IssueIcon.vue?vue&type=script&lang=ts&"
import style0 from "./IssueIcon.vue?vue&type=style&index=0&id=0f086bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f086bc8",
  null
  
)

export default component.exports